<template>
  <v-app>
    <v-toolbar app clipped-left color="blue">
      <img src="./assets/rock_fire_icon.png" height="50" width="50">
      <v-toolbar-title class="logotitle">
        Property Fire
      </v-toolbar-title>

      <v-spacer />
      <v-btn
        v-if="user"
        flat
        color="white"
        @click="logout"
      >
        Logout
      </v-btn>
      <v-btn
        v-else
        flat
        :to="{ name: 'login' }"
        color="white"
      >
        Login
      </v-btn>
    </v-toolbar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import { auth } from '@/plugins/firebase';

export default {
  name: 'App',
  data: () => ({
    user: null,
  }),
  created() {
    auth.onAuthStateChanged((user) => {
      this.user = user;
    });
  },
  methods: {
    async logout() {
      await auth.signOut();
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<style>
.logotitle {
  color: white;
}

.toolbar {
  background-color: blue;
  color: blue;
}
</style>
